import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useI18n, useLocalizedPath } from "../i18n/I18nContext";

export default function CheckoutCancel() {
  const { t } = useI18n();
  const lp = useLocalizedPath();
  return (
    <div className="container py-16 md:py-24 max-w-2xl">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="glass rounded-3xl p-10 md:p-14 text-center"
      >
        <h1 className="font-display text-section tracking-tight">{t.checkout.cancelTitle}</h1>
        <p className="mt-5 text-cream-muted">{t.checkout.cancelSub}</p>
        <Link to={lp("/guides")} className="btn btn-ghost mt-10 inline-flex">
          <ArrowLeft className="h-4 w-4" /> {t.checkout.backToGuides}
        </Link>
      </motion.div>
    </div>
  );
}
